module.exports = __webpack_public_path__ + "img/piano-1.2bea36eb.png";